import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { CountertopLinesJointTypeEnum } from '../../models/cutting/countertop';

@Component({
  template: `<div class="text-xl font-bold mt-3" i18n>Тип соединения</div>
    <mat-action-list>
      <button mat-list-item (click)="saveAndClose($event, 0)" data-testid="jointTypeNone" i18n>Нет</button>
      <button mat-list-item (click)="saveAndClose($event, 2)" data-testid="jointTypeClamp" i18n>Стяжка</button>
      <button mat-list-item (click)="saveAndClose($event, 1)" data-testid="jointTypeEurocut" i18n>Еврозапил</button>
    </mat-action-list>`,
  standalone: true,
  imports: [MatLegacyListModule],
})
export class CountertopLinesJointBottomSheetComponent {
  constructor(private _bottomSheetRef: MatBottomSheetRef<CountertopLinesJointBottomSheetComponent>) {}
  saveAndClose(event: MouseEvent, type: CountertopLinesJointTypeEnum): void {
    this._bottomSheetRef.dismiss(type);
    event.preventDefault();
  }
}
